import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import IconsList from 'common/constants/icons_map'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'

const DropDownButton = ({ current_menu, handleClick, Icono, open, small }) => {
  const isOpen = useMemo(() => {
    return current_menu?.id === open
  }, [current_menu?.id, open])
  const backgroundColor = useMemo(() => {
    return isOpen ? 'menu.hoverBackground' : 'menu.background'
  }, [isOpen])
  return (
    <React.Fragment key={`ddblibf-${current_menu.id}`}>
      <ListItemButton
        key={`ddblib-${current_menu.id}`}
        sx={{
          p: '4px',
          pl: 2,
          pr: 1,
          borderTopLeftRadius: '15px',
          borderBottomLeftRadius: '15px',
          backgroundColor: backgroundColor,
          '&:hover;&:focus': {
            backgroundColor: backgroundColor,
          },
        }}
        id={current_menu.id}
        onClick={handleClick}
        className="menu-list-item"
      >
        <ListItemIcon>
          {Icono ? <Icono sx={{ color: 'background.menuContrast', opacity: '0.8' }} /> : null}
        </ListItemIcon>
        <ListItemText primary={current_menu.nombre} />
        {open === current_menu.id ? <ExpandLess sx={{ ml: 4 }} /> : <ExpandMore sx={{ ml: 4 }} />}
      </ListItemButton>
      <Collapse
        id={current_menu.id}
        key={current_menu.id}
        in={open === current_menu.id}
        timeout="auto"
        unmountOnExit
      >
        <List
          sx={{
            backgroundColor: 'menu.hoverBackground',
            width: '90%',
            marginLeft: 'auto',
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
            pb: 1,
          }}
          component="div"
          disablePadding
        >
          {current_menu.hijos.map((sub) => {
            if (sub.cod_padre !== current_menu.codigo || sub.visible !== 'S') return null
            const IconoHijo = sub?.icono ? IconsList[sub.icono] : null
            const to =
              sub.programa === 'url' ? sub.camino : `/${sub.camino ? sub.camino : sub.programa}`
            const target = sub.programa === 'url' ? '_blank' : null
            const rel = sub.programa === 'url' ? 'noopener' : null
            const locationState = { report: sub.objeto_programa }

            if (sub.programa) {
              return (
                <ListItemButton
                  key={`${current_menu.id}-${sub.id}`}
                  sx={{ p: '4px', pl: 2, pr: 1 }}
                  id={sub.id}
                  component={Link}
                  to={to}
                  state={sub.programa === 'informes' && sub.objeto_programa ? locationState : {}}
                  target={target}
                  rel={rel}
                >
                  <ListItemIcon>
                    {IconoHijo ? <IconoHijo sx={{ color: 'background.menuContrast' }} /> : null}
                  </ListItemIcon>
                  <ListItemText primary={sub.nombre} />
                </ListItemButton>
              )
            }
            return null
          })}
        </List>
      </Collapse>
    </React.Fragment>
  )
}

export default DropDownButton
